import { cn } from "@/lib/utils";
import React from "react";
import { useSidebar } from "../ui/sidebar";
import { AppSidebar } from "./AppSidebar";
import { AppTopRightMenu } from "./AppTopRightMenu";
import { PAGE_DOCUMENT_MAX_WIDTH, PAGE_X_PADDING } from "./consts";

interface PageHeaderProps extends React.HTMLAttributes<HTMLDivElement> {
  document?: boolean;
  children?: React.ReactNode;
}

export const PageHeader: React.FC<PageHeaderProps> & {
  Title: React.FC<{ children: React.ReactNode }>;
} = ({ children, className, document, ...props }) => {
  const { open } = useSidebar();

  return (
    <header
      className={cn(
        "flex min-h-16 w-full flex-shrink-0 flex-grow-0 flex-col",
        className,
      )}
      {...props}
    >
      <div
        className={cn("transition-[min-height] duration-500 ease-in-out", {
          "min-h-8": open,
          "min-h-4": !open,
        })}
      />
      <div className={cn("flex w-full flex-col items-center", PAGE_X_PADDING)}>
        <div
          className={cn(
            "flex w-full flex-row items-start justify-between gap-4 pb-4",
            { [PAGE_DOCUMENT_MAX_WIDTH]: document },
          )}
        >
          <div className="flex flex-1">{children}</div>
          <div className="pt-1">
            <AppSidebar.WhenOpen visible={true}>
              <AppTopRightMenu.PageContentContainer className="flex flex-row items-center gap-2" />
            </AppSidebar.WhenOpen>
          </div>
        </div>
      </div>
    </header>
  );
};

const PageHeaderTitle = ({ children }: { children: React.ReactNode }) => {
  return (
    <h1 className="font-family-fancy text-4xl font-semibold">{children}</h1>
  );
};

PageHeader.Title = PageHeaderTitle;
